export default function CourseApiError(message, request = null) {
  this.name = "CourseApiError";
  this.message = message || "";
  this.request = request;
}

CourseApiError.prototype = new Error();
